import { useState, useEffect, useCallback } from 'react';
import axios from '../utility/axios';
import { useTableChanges } from './useWebSocket';

const DEFAULT_SYSTEM_SETTINGS = {
    systemUrl: '',
    defaultViews: 5,
    defaultExpiryDays: 7,
    defaultExpiryTime: '23:59',
    maxUploadSize: 10,
    allowedFileTypes: '.pdf,.xls,.xlsx,.doc,.docx,.png,.jpg,.tif,.txt',
};

export const useSystemSettings = () => {
    const [settings, setSettings] = useState(() => ({ ...DEFAULT_SYSTEM_SETTINGS }));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSystemSettings = useCallback(async (silent = false) => {
        try {
            if (!silent) {
                setLoading(true);
            }
            const response = await axios.get('/api/system-settings/');
            setSettings({
                ...DEFAULT_SYSTEM_SETTINGS,
                ...response.data,
            });
            setError(null);
        } catch (err) {
            console.error('Error fetching system settings:', err);
            setError(err);
            setSettings({ ...DEFAULT_SYSTEM_SETTINGS });
        } finally {
            if (!silent) {
                setLoading(false);
            }
        }
    }, []);

    const handleSystemSettingsChange = useCallback((change) => {
        if (change.operation === 'UPDATE' || change.operation === 'INSERT') {
            fetchSystemSettings(true);
        }
    }, [fetchSystemSettings]);

    const { isConnected } = useTableChanges('system_settings', handleSystemSettingsChange);

    useEffect(() => {
        fetchSystemSettings();
    }, [fetchSystemSettings]);

    return {
        settings,
        loading,
        error,
        refetch: () => fetchSystemSettings(),
        isRealtimeConnected: isConnected,
    };
};
